import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
const RangeDatePicker = ({ startDate, endDate, onChange }) => {
    const [range, setRange] = useState({
        startDate: startDate !== null && startDate !== void 0 ? startDate : new Date(),
        endDate: endDate !== null && endDate !== void 0 ? endDate : new Date(),
        key: 'selection'
    });
    const handleSelect = (ranges) => {
        setRange(ranges.selection);
        onChange === null || onChange === void 0 ? void 0 : onChange({ startDate: ranges.selection.startDate, endDate: ranges.selection.endDate });
    };
    return (React.createElement(DateRangePicker, { ranges: [range], onChange: handleSelect }));
};
export default RangeDatePicker;
